export default function Machines_C_7 (number = 1) {
  return {
    name: '垂直发射井',
    icon: '/static/img/machines/c7.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_7.js